export const sanitizeCalul = (value: number): number => {
  if (!value || typeof value !== 'number') return 0;
  return parseFloat(value.toFixed(2)) || 0;
};
export const sanitizePrice = (value: string): string => {
  if (!value || isNaN(Number(value))) return '0';
  return parseFloat(value).toFixed(2);
};
export const sanitizeCalculToString = (value: number): string => {
  if (!value || isNaN(value)) return '0';
  return value.toFixed(2);
};

export const toNumber = (x: number | string) => {
  if (typeof x !== 'number') x = Number(x);
  return x;
};

export const add = (x: number | string) => (y: number | string): number => {
  if (typeof x !== 'number') x = Number(x);
  if (typeof y !== 'number') y = Number(y);
  const calc = x + y;
  return Number(calc.toFixed(2));
};

export const multiply = (x: number | string) => (
  y: number | string
): number => {
  if (typeof x !== 'number') x = Number(x);
  if (typeof y !== 'number') y = Number(y);
  const calc = x * y;
  return Number(calc.toFixed(2));
};
